import { z } from 'zod'

import type { SupportedMarketKey } from '@nxt-insurance/constants'

import { getPhoneNumberSchema } from '@flows/configs/common/steps/email_and_name'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const conditionSchema = z.object({
  flows: z.object({
    core: z.object({
      configs: z.object({
        productFlow: z.object({
          values: z.object({
            phone_number: z.string(),
            helperValues: z
              .object({
                shouldConfirmPhoneNumber: z.literal(false).optional(),
              })
              .optional(),
          }),
        }),
      }),
    }),
  }),
})

export const phoneNumberConfirmation = ({ market }: { market: SupportedMarketKey }) => {
  const schema = z.object({
    phone_number: getPhoneNumberSchema(),
  })

  return {
    schema,
    stepContent: [
      {
        type: 'harmonyTitle',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.phoneNumberConfirmation.title',
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.phoneNumberConfirmation.subtitle',
        },
      },
      {
        type: 'phoneNumber',
        name: 'phone_number',
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.phoneNumberConfirmation.phone.input.label',
        },
        defaultCountry: market,
      },
    ],
    nextStep: 'progress_last_step',
    skipStep: {
      condition: (flowValues) => {
        return conditionSchema.safeParse(flowValues).success
      },
      targetStepName: 'progress_last_step',
    },
    subFlow: SubFlow.Common,
  } as const satisfies AnyStepConfiguration
}
